export enum EntityType {
    Individual="Individual",
    Company="Company"
}